import Header from "@/components/entities/header";
import { useTranslations } from "next-intl";
import ImageTextBlock from "@/components/ui/image-text-block";
import S from "./index.module.scss";

const CultureHeader = () => {
  const t = useTranslations("culture");

  return (
    <>
      <Header />
      <ImageTextBlock image="/images/culture/header.png">
        <div className={S.content}>
          <h1 className={S.title}>{t("title")}</h1>
        </div>
      </ImageTextBlock>
    </>

  )
};

export default CultureHeader;